import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { PowerIcon, ArrowRightIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 bg-sage text-white relative overflow-hidden" data-id="element-76">
      {/* Decorative background */}
      <div className="absolute inset-0 bg-pattern-dots opacity-20" data-id="element-77" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-78">
        <FadeIn data-id="element-79">
          <div className="text-center mb-12" data-id="element-80">
            <span className="inline-block py-1 px-4 rounded-full bg-white/20 text-white text-sm font-semibold tracking-wider uppercase mb-4" data-id="element-81">
              El Secreto
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-82">
              La Regulación del Nervio Vago
            </h2>
            <p className="text-xl text-white/90 max-w-2xl mx-auto" data-id="element-83">
              El secreto no está en sudar más, sino en utilizar el "Interruptor
              Biológico" de tu cuerpo.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-84">
          <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 md:p-12 border border-white/20" data-id="element-85">
            <div className="flex flex-col md:flex-row items-center justify-between gap-8 mb-10" data-id="element-86">
              <div className="flex-1 text-center md:text-right" data-id="element-87">
                <div className="text-white/60 text-sm uppercase tracking-widest mb-2" data-id="element-88">
                  Estado Actual
                </div>
                <div className="text-2xl font-serif font-bold text-red-200" data-id="element-89">
                  Lucha o Huida
                </div>
                <div className="text-sm text-white/70 mt-1" data-id="element-90">
                  Cortisol alto, inflamación
                </div>
              </div>

              <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center text-sage shadow-lg shrink-0 relative" data-id="element-91">
                <PowerIcon size={32} data-id="element-92" />
                <div className="absolute inset-0 rounded-full border-2 border-white animate-ping opacity-20" data-id="element-93" />
              </div>

              <div className="flex-1 text-center md:text-left" data-id="element-94">
                <div className="text-white/60 text-sm uppercase tracking-widest mb-2" data-id="element-95">
                  El Objetivo
                </div>
                <div className="text-2xl font-serif font-bold text-gold-light" data-id="element-96">
                  Descanso y Reparación
                </div>
                <div className="text-sm text-white/70 mt-1" data-id="element-97">
                  Quema de grasa, energía
                </div>
              </div>
            </div>

            <div className="text-center" data-id="element-98">
              <p className="text-xl md:text-2xl font-medium leading-relaxed" data-id="element-99">
                "Cuando tu sistema nervioso se siente seguro, el cortisol baja,
                la retención de líquidos desaparece y tu metabolismo se enciende
                de nuevo de forma natural."
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}